import { Fragment } from 'react';

import antConfig from '@/ant-config';
import AppLoader from '@/react_app/common/AppLoader';
import RouterLink from '@/react_app/common/RouterLink';
import SectionCard from '@/react_app/components/BillingUsage/Global/SectionCard';
import { OverviewSectionProps } from '@/react_app/components/BillingUsage/Overview/types';
import {
	BILLING_USAGE_SETTINGS_ROUTE_NAME,
	BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME,
} from '@/router/BillingUsage/billing-usage-router.const';
import { CUSTOMIZE_PLAN_ROUTE_NAME } from '@/router/router.const';
const OverviewSection = ({
	planRenewDate,
	isLoadingPrices,
	planRenewableAmount,
	mainCardLast4Digits,
	emailsReceivingReceipts,
}: // isSmartUpgradeOn,
OverviewSectionProps) => (
	<SectionCard className="max-w-6xl" sectionTitle="Overview">
		<div className="space-y-[22px]">
			{isLoadingPrices ? (
				<AppLoader class="text-left" />
			) : planRenewableAmount === '$0' ? (
				<p className="text-sm">Your plan is free</p>
			) : (
				<p className="text-sm">
					Your plan will renew on <strong>{planRenewDate}</strong> for <strong>{planRenewableAmount}</strong> (inclusive of applicable tax).
				</p>
			)}
			<RouterLink
				target="_blank"
				to={{ name: CUSTOMIZE_PLAN_ROUTE_NAME }}
				style={{ color: antConfig.token?.['purple-6'] }}
				className="underline hover:no-underline text-[13px]"
			>
				Edit plan
			</RouterLink>
			{/* <div className="text-[13px]">
				<p style={{ color: antConfig.token?.colorTextSecondary }}>
					Smart upgrade is{' '}
					<strong
						style={{
							color: antConfig.token?.colorText,
						}}
					>
					{isSmartUpgradeOn ? 'on' : 'off'}
					</strong>
				</p>
				<RouterLink
					style={{ color: antConfig.token?.['purple-6'] }}
					to={{ name: BILLING_USAGE_SETTINGS_ROUTE_NAME }}
					className="underline hover:no-underline text-[13px]"
					>
					Edit smart upgrade settings
					</RouterLink>
					</div> */}

			<div className="text-[13px]">
				{mainCardLast4Digits ? (
					<p style={{ color: antConfig.token?.colorTextSecondary }}>
						Future charges will be billed to the card ending in{' '}
						<strong style={{ color: antConfig.token?.colorText }}>{mainCardLast4Digits}</strong>
					</p>
				) : (
					<p style={{ color: antConfig.token?.colorTextSecondary }}>No payment method has been added yet</p>
				)}
				<RouterLink
					style={{ color: antConfig.token?.['purple-6'] }}
					to={{ name: BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME }}
					className="underline hover:no-underline text-[13px]"
				>
					{mainCardLast4Digits ? 'Change' : 'Add'} payment method
				</RouterLink>
			</div>

			<div className="text-[13px]">
				<p
					style={{
						color: antConfig.token?.colorTextSecondary,
					}}
				>
					Billing emails are sent to{' '}
					{emailsReceivingReceipts.map((email, index) => (
						<Fragment key={email}>
							<strong style={{ color: antConfig.token?.colorText }}>{email}</strong>
							{index === emailsReceivingReceipts.length - 2 ? ' and ' : index !== emailsReceivingReceipts.length - 1 ? ', ' : ''}
						</Fragment>
					))}
				</p>
				<RouterLink
					style={{ color: antConfig.token?.['purple-6'] }}
					to={{ name: BILLING_USAGE_SETTINGS_ROUTE_NAME }}
					className="underline hover:no-underline text-[13px]"
				>
					Edit billing contacts
				</RouterLink>
			</div>
		</div>
	</SectionCard>
);

export default OverviewSection;
